import { fade, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  invoiceStepWrapper: {
    width: '100%',
    padding: theme.spacing(3, 3, 5),
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  confirmationWrapper: {
    textAlign: 'center',
    '& h6': {
      fontWeight: theme.typography.fontWeightSemiBold
    }
  },
  successHeader: {
    color: theme.palette.success.dark,
    '& svg': {
      fontSize: theme.typography.pxToRem(72)
    }
  },
  successMessage: {
    marginTop: theme.spacing(2)
  },
  submissionIdWrapper: {
    backgroundColor: fade(theme.palette.success.main, 0.1),
    width: 'auto',
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(3),
    padding: theme.spacing(3),
    fontSize: theme.typography.pxToRem(20),
    border: `1px solid ${theme.palette.success.light}`
  },
  submissionId: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.pxToRem(24),
    color: theme.palette.common.black
  },
  linkBtn: {
    textTransform: 'none',
    transition: 'all 0.3s ease-in-out',
    fontSize: theme.typography.pxToRem(16),
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    '&:hover, &:focus': {
      color: theme.palette.secondary.main,
      backgroundColor: 'transparent'

    }
  }
}))
